exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".blog-post-header{position:relative;max-width:900px;min-height:70px;margin-bottom:40px}.blog-post-header div{display:inline-block}.blog-post-header .blog-title{font-weight:600;margin-left:100px;max-width:800px}.blog-post-header .datum-header{margin-left:100px;margin-top:10px;margin-right:5px}.blog-post-header .category:before{content:url(" + require("./icon-design.png") + ");margin-left:30px;margin-right:5px}.blog-post-header .comments:before{content:url(" + require("./icon-comments.png") + ");margin-left:30px;margin-right:5px}.blog-post-header a{text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-023d9d5e","scoped":false,"hasInlineConfig":true}!./src/components/blog-post-header/blog-post-header.css
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-023d9d5e","scoped":false,"hasInlineConfig":true}!./src/components/blog-post-header/blog-post-header.css
// module chunks = index